<template>
  <div class="videos pb-9">
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">مدیریت ویدئو های اموزشی</h4>
        <v-divider class="me-10 ms-10 d-none d-md-block" vertical></v-divider>
        <div class="custom-input2 mt-3 mt-md-0">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو در نام ویدئو ..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col
              cols="12"
              xl="10"
              lg="10"
              md="10"
              sm="8"
              xs="12"
              class="d-flex flex-row"
            >
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="4" xs="12">
              <v-btn
                @click="openNewVideos()"
                @shortkey="openNewVideos()"
                v-shortkey.once="['n']"
                class="purple-borderedBtn"
                height="43"
                block
              >
                <v-icon class="me-1">mdi-plus</v-icon>افزودن ویدئو جدید
              </v-btn>
            </v-col>
          </v-row>
          <hr />
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="authorsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(fileUrl)="data">
                <div style="text-align: center; vertical-align: middle" class="less-text">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <v-row>
                  <v-col cols="12" sm="6" xs="12">
                    <v-btn
                      class="green-mainBtn"
                      block
                      @click="openEditDialog(row.item)"
                    >
                      ویرایش</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="6" xs="12">
                    <v-btn
                      class="red-mainBtn"
                      block
                      @click="openDeletDialog(row.item)"
                    >
                      حذف</v-btn
                    >
                  </v-col>
                </v-row>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <div class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-sm-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>

    <v-dialog v-model="newVideosDialog" width="500">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>ثبت ویدئو جدید</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="cancelVideo()"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />

        <v-card-text class="pa-2">
          <v-row>
            <v-col class="pt-0" cols="12" md="12" sm="12">
              <div
                class="video-box pointer"
                @click="$refs.videohelp.$refs.input.click()"
              >
                <div class="video-box pointer">
                  <video controls class="video" v-if="newVideos.fileId">
                    <source :src="newVideos.fileUrl" />
                  </video>
                  <img v-else src="/no-image.png" alt="" />
                </div>

                <v-icon x-large class="video-icon white--text"
                  >mdi-video</v-icon
                >
                <div class="video-loading" v-if="videoLoading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :size="40"
                  ></v-progress-circular>
                  <h6 class="mt-4 grey--text text--darken-4">
                    در حال بارگذاری...
                  </h6>
                </div>
              </div>
            </v-col>
            <v-col class="pt-0" cols="12" md="12" sm="12">
              <v-btn
                class="purple-mainBtn pa-5"
                block
                @click="$refs.videohelp.$refs.input.click()"
              >
                <v-icon class="me-2">mdi-video</v-icon>
                بارگذاری ویدئو
              </v-btn>
              <v-file-input
                v-show="false"
                @change="newVideoUpload(videomain)"
                v-model="videomain"
                ref="videohelp"
              ></v-file-input>
            </v-col>
            <v-col class="py-0" cols="12" md="12" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام ویدئو :</label
              >
              <v-text-field
                placeholder="نام ویدئو "
                outlined
                dense
                v-model="newVideos.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="addVideos()"
                :disabled="busy || !isValidNewVideo"
                class="green-mainBtn white--text"
                block
              >
                <atom-spinner
                  v-if="busy"
                  :animation-duration="1000"
                  :size="20"
                  :color="'#fff'"
                />
                <span v-else>افزودن</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="cancelVideo()"
                block
              >
                لغو
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editVideoDialog" width="500">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>
                ویرایش ویدئو <span>{{ editVideo.name }}</span>
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="editVideoDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />
        <div
          v-if="loading2"
          class="d-flex flex-column align-items-center mt-8 py-6"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="50"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <v-card-text class="pa-2" v-else>
          <v-row>
            <v-col class="pt-0" cols="12" md="12" sm="12">
              <div
                class="video-box pointer"
                @click="$refs.editvideohelp.$refs.input.click()"
              >
                <video controls class="video">
                  <source
                    :src="
                      editVideo.fileId ? editVideo.fileUrl : '/no-image.png'
                    "
                  />
                </video>
                <v-icon x-large class="video-icon white--text"
                  >mdi-video</v-icon
                >
                <div class="video-loading" v-if="editvideoLoading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :size="40"
                  ></v-progress-circular>
                  <h6 class="mt-4 grey--text text--darken-4">
                    در حال بارگذاری...
                  </h6>
                </div>
              </div>
            </v-col>
            <v-col class="pt-0" cols="12" md="12" sm="12">
              <v-btn
                class="purple-mainBtn pa-5"
                block
                @click="$refs.editvideohelp.$refs.input.click()"
              >
                <v-icon class="me-2">mdi-video</v-icon>
                بارگذاری ویدئو
              </v-btn>
              <v-file-input
                v-show="false"
                @change="editVideoUpload(editvideoMain)"
                v-model="editvideoMain"
                ref="editvideohelp"
              ></v-file-input>
            </v-col>
            <v-col class="py-0" cols="12" md="12" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام ویدئو :</label
              >
              <v-text-field
                placeholder="ویدئو  نام "
                outlined
                dense
                v-model="editVideo.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="doEditVideo()"
                :disabled="editLoading"
                class="green-mainBtn white--text"
                block
              >
                ویرایش
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="editVideoDialog = false"
                block
              >
                لغو
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteVideoDialog" width="500">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>
                حذف ویدئو <span>{{ editVideo.name }}</span>
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="deleteVideoDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />
        <div v-if="loading2" class="d-flex flex-column align-items-center">
          <atom-spinner
            :animation-duration="1000"
            :size="40"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <v-card-text class="pa-2" v-else>
          <v-row>
            <v-col cols="12" class="content-modal-publisher">
              <h4>
                آیا از حذف ویدئو <span>{{ editVideo.name }}</span
                >اطمینان دارید؟
              </h4>
            </v-col>

            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="doDeletaVideo()"
                :disabled="deleteLoading"
                class="green-mainBtn white--text"
                block
              >
                بلی
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="deleteVideoDialog = false"
                block
              >
                لغو
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "VideosManager",
  components: {
    AtomSpinner,
  },
  data() {
    return {
      tab: null,
      filter: "",
      guide: false,
      busy: false,
      editLoading: false,
      deleteLoading: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      newpreinterestRateErrors: [],
      newprepaymentRateErrors: [],
      editpreinterestRateErrors: [],
      editprepaymentRateErrors: [],
      videos: [],
      editauthorsImage: {},
      authorsImage: {},
      editauthorsImageLoading: false,
      authorsImageLoading: false,
      newVideos: {},
      editVideo: {},
      selectedVideo: {},
      newVideosDialog: false,
      editVideoDialog: false,
      deleteVideoDialog: false,
      loading: false,
      loading2: false,
      authorsFields: [
        {
          key: "index",
          label: "ردیف",
          align: "center",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "name",
          label: "نام ویدئو ",
          align: "center",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "fileUrl",
          label: " لینک ویدئو ",
          align: "center",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "operation",
          label: "عملیات",
          align: "center",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      whichPage: 1,
      myVideo: new Object({
        uploadPercentage: 0,
      }),
      videoLoading: false,
      videomain: [],
      editvideoLoading: false,
      editvideoMain: [],
      editMyMainVideo: new Object({
        uploadPercentage: 0,
      }),
    };
  },

  computed: {
    computedItems() {
      let filtered;
      filtered = this.videos.filter((x) => x.name.includes(this.filter));
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedItems.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },

    isValidNewVideo() {
      return this.newVideos.name;
    },
  },
  mounted() {
    this.showVideos();
  },
  methods: {
    openNewVideos() {
      this.newVideosDialog = true;
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },

    showVideos() {
      this.loading = true;
      Axios.get(this.baseUrl + "/satrapp/guides/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.videos = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    newVideoUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 100) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 100 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else {
        this.myVideo.showProgress = true;
        this.myVideo.variant = "info";
        this.myVideo.uploadPercentage = 0;
        this.myVideo.isUploaded = false;
        this.myVideo.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.videoLoading = true;
        Axios.post(this.baseUrl + "/satrapp/guide/draft", formData, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myVideo.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        })
          .then((d) => {
            if (d.status == 200) {
              this.toast(d.data.message, "success");
              this.myVideo.isUploaded = true;
              this.myVideo.uploadPercentage = 100;
              this.myVideo.striped = false;
              this.myVideo.variant = "success";
              this.myVideo.uploadButDisable = false;
              this.newVideos.fileId = d.data.id;
              this.newVideos.fileUrl = d.data.url;
              this.videoLoading = false;
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.videoLoading = false;
          });
      }
    },
    addVideos() {
      if (!this.isValidNewVideo) return;
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/guide/new",
        {
          name: this.newVideos.name ? this.newVideos.name : undefined,
          fileId: this.newVideos.fileId ? this.newVideos.fileId : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newVideos = {
              name: "",
            };
            this.newVideosDialog = false;
            this.showVideos();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.newVideosDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
          this.newVideosDialog = false;
        });
    },
    cancelVideo() {
      this.newVideosDialog = false;
      this.newVideos = {};
    },
    openEditDialog(item) {
      this.selectedVideo = item.id;
      this.getVideoInfo();
      this.editVideoDialog = true;
    },
    getVideoInfo() {
      this.loading2 = true;
      Axios.get(this.baseUrl + "/satrapp/guide/getData/" + this.selectedVideo, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.editVideo = res.data;
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading2 = false;
        });
    },
    editVideoUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 100) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 100 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else {
        this.editMyMainVideo.showProgress = true;
        this.editMyMainVideo.variant = "info";
        this.editMyMainVideo.uploadPercentage = 0;
        this.editMyMainVideo.isUploaded = false;
        this.editMyMainVideo.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.editvideoLoading = true;
        Axios.post(
          this.baseUrl + "/satrapp/guide/upload/" + this.selectedVideo,
          formData,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
            onUploadProgress: ((progressEvent) => {
              this.editMyMainVideo.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          }
        )
          .then((d) => {
            if (d.status == 200) {
              this.toast(d.data.message, "success");
              this.editMyMainVideo.isUploaded = true;
              this.editMyMainVideo.uploadPercentage = 100;
              this.editMyMainVideo.striped = false;
              this.editMyMainVideo.variant = "success";
              this.editMyMainVideo.uploadButDisable = false;
              this.editVideo.fileId = d.data.id;
              this.editVideo.fileUrl = d.data.url;
              this.editvideoLoading = false;
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.editvideoLoading = false;
          });
      }
    },
    doEditVideo() {
      this.editLoading = true;
      Axios.patch(
        this.baseUrl + "/satrapp/guide/edit/" + this.selectedVideo,
        {
          name: this.editVideo.name,
          fileId: this.editVideo.fileId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.editLoading = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.showVideos();
            this.editVideoDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.editVideoDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.editLoading = false;
          this.editVideoDialog = false;
        });
    },
    openDeletDialog(item) {
      this.selectedVideo = item.id;
      this.getVideoInfo();
      this.deleteVideoDialog = true;
    },
    doDeletaVideo() {
      this.deleteLoading = true;
      Axios.delete(
        this.baseUrl + "/satrapp/guide/delete/" + this.selectedVideo,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.deleteLoading = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.showVideos();
            this.deleteVideoDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.deleteVideoDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.deleteLoading = false;
          this.deleteVideoDialog = false;
        });
    },
  },
};
</script>
<style lang="scss">
.videos {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.product-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7c4dff !important;
        cursor: pointer;
      }
    }
  }
}

.video-box {
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 300px;
  border: none;

  &:hover {
    background-color: #3c03923b !important;

    video,
    img {
      opacity: 0.7;
    }

    .video-icon {
      display: block;
    }
  }

  video,
  img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .video-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  .video-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3c03923b;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
